import { createContext, useContext } from "react";

import type { AuthInterface } from "./types";

const AuthContext = createContext<AuthInterface>(
  null as unknown as AuthInterface,
);

export const AuthProvider = AuthContext.Provider;

export const useAuth = () => useContext(AuthContext);
